module.exports = __webpack_public_path__ + "static/media/15.d50adc20.jpg";